import { createContext, useState, useEffect, useMemo, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

/* AUTO-GENERATED from @pomelo/tokens. Do not edit — run `pnpm sync:theme`. */

var ThemeContext = createContext(null);
var STORAGE_KEY = "pomelo-theme";
function ThemeProvider({
  children,
  defaultTheme = "default",
  availableThemes = ["default", "dark"],
  storageKey = STORAGE_KEY
}) {
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined" || !storageKey) return defaultTheme;
    const stored = window.localStorage.getItem(storageKey);
    return stored || defaultTheme;
  });
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("data-theme", theme);
    if (storageKey) window.localStorage.setItem(storageKey, theme);
  }, [theme, storageKey]);
  const value = useMemo(
    () => ({ theme, setTheme: setThemeState, availableThemes }),
    [theme, availableThemes]
  );
  return /* @__PURE__ */ jsx(ThemeContext.Provider, { value, children });
}
function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside <ThemeProvider>");
  return ctx;
}

export { ThemeProvider, useTheme };
